// extracted by mini-css-extract-plugin
export default {"news":"News_news__8sYp+","image":"News_image__Biqqx","title":"News_title__qu+5l"};